import React, { useMemo } from 'react';
import { themeCalm, themePodcast, themeUniversal, themeWork, ThemeProvider as MMThemeProvider } from '@missionme/mime_elements';
import { useRouteData } from 'Application/RouteDataProvider/RouteDataProvider';

export const ThemeProvider = ({ children, theme }) => {
  const { currentRoute } = useRouteData();

  const _theme = useMemo(() => {
    if (theme) {
      return theme;
    }
    switch (true) {
      case currentRoute?.theme === 'work':
        return themeWork;
      case currentRoute?.theme === 'calm':
        return themeCalm;
      case currentRoute?.theme === 'podcast':
        return themePodcast;
      default:
        return themeUniversal;
    }
  }, [currentRoute, theme]);

  return <MMThemeProvider theme={_theme}>{children}</MMThemeProvider>;
};
